module.exports = __webpack_public_path__ + "img/img_success.71971fcb.png";